export default __webpack_public_path__ + "static/media/r9.70450e24.jpg";